import {CHANGE_ODDS_TYPE, CHANGE_SYSTEM_LANGUAGE, OPEN_CLOSE_SETTINGS} from '../constants/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case OPEN_CLOSE_SETTINGS:
            let newIsSettingsOpen = !state.isSettingsOpen;
            return {
                ...state,
                isSettingsOpen: newIsSettingsOpen
            };
        case CHANGE_ODDS_TYPE:
            return {
                ...state,
                selectedOddsType: action.oddsType
            };

        case CHANGE_SYSTEM_LANGUAGE:
        document.documentElement.lang = action.language
        document.getElementById('accaboostBannerCheck').style.visibility="visible";
            return {
                ...state,
                systemLanguage: action.language
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/settingsReducer.js